import React from "react"

function PreviewAnswer({
  answer
}) {
  return (
    <button
      className="btn btn-survey"
      id={answer.id}
      data-slug={answer.slug}
      type="button"
      defaultValue={answer.label}>
      <input type="radio" />
      {answer.label}
    </button>
  )
}

export default PreviewAnswer